import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pr-2" }

import ArrowRightIcon from "@/components/Icons/components/ArrowRightIcon.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'RotatingArrow',
  props: {
      rotateArrow: Boolean,
    },
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(ArrowRightIcon, {
      class: _normalizeClass({rotate180: __props.rotateArrow, rotate0: !__props.rotateArrow})
    }, null, 8, ["class"])
  ]))
}
}

})